import React from 'react';
import PropTypes from 'prop-types';
import BootstrapCard from "shared/components/bootstrapCard/BootstrapCard";
import ConnectedTextField from "shared/components/connectedTextField/ConnectedTextFieldConnector";
import { EXCEL_FILE, getFileTypeCategory } from 'shared/helpers/fileTransferHelper';

const FilePropertiesPanel = ({ fileExtension, loading }) => {
  const defaultTextFieldStyle = { width: 60, marginRight: 90 };
  const currencySymbols = [
    { itemValue: '$', primaryText: '$' },
    { itemValue: '€', primaryText: '€'},
    { itemValue: '£', primaryText: '£'}
  ];
  return (
    <BootstrapCard
      title="3. File Properties"
      minWidth={ 1000 }
      loading={ loading }
      margin={ '15px 0' }
    >
      <div>
        <ConnectedTextField type="leftLabeled" label="Date Format" name="dateFormat" textFieldStyle={ { ...defaultTextFieldStyle, width: 120 } }  />
        <ConnectedTextField type="leftLabeled" label="Thousand Separator" name="thousandsSeparator"  textFieldStyle={ defaultTextFieldStyle } />
        <ConnectedTextField type="leftLabeled" label="Decimal" name="decimalSeparator" textFieldStyle={ defaultTextFieldStyle } />
        {
          getFileTypeCategory(fileExtension) !== EXCEL_FILE &&
          <ConnectedTextField type="leftLabeled" label="Column Delimiter" name="columnDelimiter" textFieldStyle={ defaultTextFieldStyle } required />
        }
        <ConnectedTextField type="dropDownAccumulator" label="Strip Currency Symbols" name="stripCurrencySymbols" elementsToShow={ currencySymbols } id="stripCurrencySymbols" />
      </div>
    </BootstrapCard>
  );
};

FilePropertiesPanel.propTypes = {
  fileExtension: PropTypes.string,
  loading: PropTypes.bool
};

FilePropertiesPanel.defaultProps = {
  fileExtension: '',
  loading: false
};

export default FilePropertiesPanel;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/filePropertiesPanel/FilePropertiesPanel.js